
import actions from './moduleKontakActions.js'
import mutations from './moduleKontakMutations.js'
import state from './moduleKontakState.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
